import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SarState } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
    providedIn: 'root'
})
export class SarStateService {
    constructor(private http: HttpClient) { }

    get(options?: any) {
        const opts = options || {};
        let query = Object.keys(opts)
            .map(key => `${key}=${opts[key]}`)
            .join('&');
        query = query ? `?${query}` : '';

        return this.http.get<SarState[]>(`${API}sar_states${query}`);
    }
    create(sar_state: SarState) {
        return this.http.post<SarState>(`${API}sar_states`, sar_state);
    }

    // TODO: CHANGE route?
    //   delete(PortId: number) {
    //     return this.http.put<Port>(`${API}sar_states/delete`, { PortId });
    //   }
    update(SarStateId: number, data) {
        return this.http.put<SarState>(`${API}sar_states/${SarStateId}`, data);
    }
}
